<template>
    <el-container>
        <div class="page-hello-row">
            <p>Hi {{trueName}}. 下午好! 今天是 {{week_day}}</p>
        </div>

        <div>
            <transition name="el-zoom-in-center">
                <div class="transition-box">总路线数：{{total_all_roads}}</div>
            </transition>
            
            <transition name="el-zoom-in-center">
                <div class="transition-box">进行中路线：{{total_running_roads}}</div>
            </transition>

            <transition name="el-zoom-in-center">
                <div class="transition-box">漏检：{{total_running_roads}}</div>
            </transition>

            <transition name="el-zoom-in-center">
                <div class="transition-box">巡检人员：{{total_peoples}}</div>
            </transition>

            <transition name="el-zoom-in-center">
                <div class="transition-box">完成率：{{complete}}</div>
            </transition>

        </div>

        <el-row :gutter="20">
            <el-col :span="24">
                <div class="abnormal-box">
                    <div class="title">今日打卡记录</div>
                    <div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%">
                            <el-table-column
                              prop="number"
                              label="序号"
                              width="50">
                            </el-table-column>
                            <el-table-column
                              prop="create_time"
                              label="巡检时间"
                              width="180">
                            </el-table-column>
                            <el-table-column
                              prop="patrol_name"
                              label="巡检点名称">
                            </el-table-column>
                            <el-table-column
                              prop="object_name"
                              label="设备名称"
                              width="150">
                            </el-table-column>
                            <el-table-column
                              prop="device_no"
                              label="IMEI/SN"
                              width="200">
                            </el-table-column>
                            <el-table-column
                              prop="card_no"
                              label="巡检点卡号"
                              width="200">
                            </el-table-column>
                            <el-table-column
                              prop="true_name"
                              label="巡检人"
                              width="150">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="dv-pagging-container">
                        <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="pagging.pager_size"
                        :pager-count="pagging.pager_count"
                        :total="pagging.records_total">
                        </el-pagination>
                    </div>
                </div>
            </el-col>
        </el-row>

        <div class="patrol_row-spacing">&nbsp;</div>

    </el-container>
</template>

<script>
import * as echarts from 'echarts'
import Api from '../api/index'

export default {
    name: 'home_dashboard',
    data() {
        return {
            trueName: "",
            week_day: "",
            total_all_roads: 0,
            total_running_roads: 0,
            total_peoples: 0,
            complete: "100%",
            tableData: [],
            pagging: {
                records_total: 0,
                pager_count: 5,
                pager_size: 20,
                current_page: 1
            }
        }
    },
    methods: {
        initHomeData: function() {
            this.trueName = localStorage.getItem("true_name") || "";

            var date = new Date();
            this.week_day = this.getWeekday(date);  // 输出当前日期的星期几

            var argdata = {};  // {HoldID:0}
            Api.GetDashboardSummary(argdata).then(res => {
                if(!res)
                    return;
                if(res.code !== 200) {
                    //this.$message.error(err);
                    return;
                }
                if(res.data) {
                    this.total_all_roads = res.data[0].all_roads;
                    this.total_running_roads = res.data[0].running_roads;
                    this.total_peoples = res.data[0].patrol_people_num;
                }
            });

            this.loadTodayPatrolLogs();
        },
        loadTodayPatrolLogs: function() {
            var argdata = {
                PageIndex: this.pagging.current_page,
                PageSize: this.pagging.pager_size
            };
            Api.GetTodayPatrolLogs(argdata).then(res => {
                if(!res)
                    return;
                if(res.code !== 200) {
                    //this.$message.error(err);
                    return;
                }
                if(res.data) {
                    this.pagging.records_total = res.total;
                    res.data.forEach((x, i) => {
                        this.tableData.push({
                            number: (i + 1),
                            create_time: x.create_time,
                            patrol_name: x.patrol_name,
                            card_no: x.card_no,
                            device_no: x.device_no,
                            object_name: x.object_name,
                            true_name: x.true_name
                        });
                    });
                }
            });
        },
        getWeekday: function(date) {
            var weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            return weekdays[date.getDay()];
        },
        initLineChart() {
            const chartDom = this.$refs.lineChart1;
            const myChart = echarts.init(chartDom);
            const option = {
                title: {
                  text: '运行日统计'
                },
                xAxis: {
                  type: 'category',
                  data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                  type: 'value'
                },
                series: [{
                  data: [820, 932, 901, 934, 1290, 1330, 1320],
                  type: 'line'
                }]
            };
     
            myChart.setOption(option);

            var chartDom2 = this.$refs.lineChart2;
            var myChart2 = echarts.init(chartDom2);
            const option2 = {
                title: {
                  text: '运行月统计'
                },
                legend:{
                    data:['计划线路','完成线路']
                },
                xAxis: {
                  data: ['6月', '7月', '8月', '9月', '10月', '11月', '12月']
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                    {
                        type: 'bar',
                        data: [56, 58, 86, 85, 67, 79, 88],
                        name: "计划线路"
                    },
                    {
                        type: 'bar',
                        data: [54, 55, 86, 80, 67, 70, 86],
                        name: "完成线路"
                    }
                ]
            };
            myChart2.setOption(option2);
        }
    },
    mounted() {
        this.initHomeData();
    }
}
</script>

<style>
.cardbox {
    margin-left: 20px;
    margin-bottom: 10px;
    border: #dddddd 1px solid;
    width: 200px;
}
.cardbox > div.title {
    padding: 10px 10px;
    background: #dddddd;
    font-size: 16px;
}
.cardbox-weight {
    color: #333333;
    font-size: 22px;
}

.patrol_row-spacing {
    width: 100%;
    height: 20px;
}

.cardchart {
    margin-left: 20px;
    margin-bottom: 10px;
    padding-top: 10px;
    border: #dddddd 1px solid;
    width: 600px;
    height: 400px;
}

.abnormal-box {
    margin-top: 20px;
    margin-left: 15px;
    width: 95%;
    border: #dddddd 1px solid;
}
.abnormal-box > div.title {
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    background-color: #5fafff;
    color: #ffffff;
    font-size: 16px;
}

.transition-box {
    float: left;
    margin-left: 15px;
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #5fafff;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
    font-size: 16px;
}
</style>